import React from 'react';
import './MTDP.css';

const MTDP = () => {
  return (
    <div className="mtdp-structure">
      <div className="mtdp-wrapper">
        <h2 className="mtdp-title">📘 2025–2029 Medium Term Development Plan (MTDP)</h2>
        <p className="mtdp-intro">
          The Igbo-Eze North 2025–2029 Medium Term Development Plan is a bold roadmap for inclusive growth, infrastructure renewal, and human development.
          Developed through wide-ranging consultations with communities, NGOs, traditional leaders, and private sector actors, the Plan reflects our collective aspirations for a more prosperous and resilient local government.
        </p>

        <section className="mtdp-section">
          <h3>🎯 Our Development Vision</h3>
          <p>
            "To build a prosperous, inclusive, and sustainable community where every resident enjoys a high quality of life, empowered with opportunities for growth and development."
          </p>
        </section>

        <section className="mtdp-section">
          <h3>🧭 Strategic Focus Areas</h3>
          <p>The plan is anchored on six key pillars designed to drive long-term transformation:</p>
          <ol>
            <li>
              <strong>Economic Growth & Livelihoods</strong>
              <ul>
                <li>Boost agricultural productivity and food security</li>
                <li>Establish farm estates and agro-processing centres</li>
                <li>Support MSMEs through microfinance and training</li>
                <li>Expand markets and commercial infrastructure</li>
              </ul>
            </li>
            <li>
              <strong>Human Capital Development</strong>
              <ul>
                <li>Improve school infrastructure and enrollment</li>
                <li>Provide scholarships and vocational training</li>
                <li>Upgrade PHCs</li>
                <li>Expand community-based health insurance coverage</li>
              </ul>
            </li>
            <li>
              <strong>Infrastructure & Basic Services</strong>
              <ul>
                <li>Rehabilitate 300km of rural roads</li>
                <li>Install 700 solar streetlights and 20 transformers</li>
                <li>Construct water facilities and sanitation systems</li>
                <li>Extend electricity and build portable homes</li>
              </ul>
            </li>
            <li>
              <strong>Governance & Institutional Reform</strong>
              <ul>
                <li>Strengthen transparency, budget monitoring, and audits</li>
                <li>Establish a public service feedback system</li>
                <li>Build a functional digital presence</li>
                <li>Train 200 officials in public financial management</li>
              </ul>
            </li>
            <li>
              <strong>Security, Justice & Social Inclusion</strong>
              <ul>
                <li>Support community policing and conflict resolution</li>
                <li>Provide legal aid and scholarships for women and girls</li>
                <li>Launch GBV and mental health campaigns</li>
                <li>Install surveillance in security flashpoints</li>
              </ul>
            </li>
            <li>
              <strong>Environmental Sustainability & Climate Action</strong>
              <ul>
                <li>Plant 10,000 trees to combat land degradation</li>
                <li>Promote sustainable farming practices</li>
                <li>Improve solid waste management</li>
                <li>Construct gender-sensitive public toilets</li>
              </ul>
            </li>
          </ol>
        </section>

        <section className="mtdp-section">
          <h3>📊 Monitoring & Implementation</h3>
          <p>
            A dedicated Implementation Unit under the PRS Department ensures that all MTDP activities are tracked and reviewed.
            Progress reports are shared quarterly via community forums, state agencies, and this website.
          </p>
        </section>

        <section className="mtdp-section">
          <h3>💰 Funding Strategy</h3>
          <p>Projects are financed through:</p>
          <ul>
            <li>FAAC allocations</li>
            <li>Internally generated revenue (IGR)</li>
            <li>Public-private partnerships (PPPs)</li>
            <li>Grants from development partners and donor agencies</li>
          </ul>
        </section>

        <section className="mtdp-section">
          <p>
            The 2025–2029 MTDP is more than a document — it is our contract with the people of Igbo-Eze North. It’s how we plan, build, and deliver a brighter future.
          </p>
        </section>
      </div>
    </div>
  );
};

export default MTDP;